import { getInitials, getInitialsFromParts } from '../utils';

interface PatientAvatarProps {
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-12 w-12 text-sm',
  lg: 'h-16 w-16 text-xl',
};

export function PatientAvatar({ name, firstName, lastName, size = 'sm' }: PatientAvatarProps) {
  const initials = firstName !== undefined || lastName !== undefined
    ? getInitialsFromParts(firstName, lastName)
    : getInitials(name);

  return (
    <div className={`flex shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-medium ${sizeClasses[size]}`}>
      {initials}
    </div>
  );
}
